export const devices = [
  'Samsung Galaxy Z Flip - SM-F700',
  'Samsung Fold 1 - SM-F907',
  'Samsung Galaxy Z Fold2 5G 256GB- SM-F916',
  'Samsung Galaxy Z Flip 3 128GB',
  'Samsung Galaxy Z Flip 3 256GB',
  'Samsung Galaxy Z Fold 3 256GB',
  'Samsung Galaxy Z Fold 3 512GB',
  'Samsung Galaxy Z Flip4 128GB',
  'Samsung Galaxy Z Flip4 256GB',
  'Samsung Galaxy Z Flip4 512GB',
  'Samsung Galaxy Z Fold 4 256GB',
  'Samsung Galaxy Z Fold 4 512GB',
];
